import React from "react";
import cx from "classnames";
import { GatsbyImage, getImage, ImageDataLike } from "gatsby-plugin-image";

// import { Heading } from "components/ui/Heading";

import * as s from "./CollaborationCard.module.sass";

export type ICollaboration = {
  image: ImageDataLike;
  label: string;
};

type CollaborationCardProps = {
  collaboration: ICollaboration;
};

export const CollaborationCard: FC<CollaborationCardProps> = ({
  collaboration: { image, label },
  className,
}) => {
  const imagePrepared = getImage(image)!;

  return (
    <div className={cx(s.root, className)}>
      <GatsbyImage
        image={imagePrepared}
        objectFit="contain"
        alt={label}
        className={s.image}
      />
      {/*<Heading type="h4" as="h3" className={s.title}>*/}
      {/*  {label}*/}
      {/*</Heading>*/}
    </div>
  );
};
